import { useNavigate } from 'react-router-dom';
import {
  ArrowLeft,
  FolderPlus,
  Edit2,
  Archive,
  RefreshCw,
  Save,
  X,
  MapPin,
  Search,
  Loader2,
  LayoutList,
  Building2,
  Trash2,
  ChevronDown,
  ChevronUp,
  Users,
  BedDouble,
  FileText
} from 'lucide-react';
import { Card } from '../components/ui/Card';
import { LoadingSpinner } from '../components/ui/LoadingSpinner';
import { EmptyState } from '../components/ui/EmptyState';
import { useProjectsData, getEntityColors } from '../hooks/useProjectsData';
import { useProjectsActions } from '../hooks/useProjectsActions';

export default function AdminProjects() {
  const navigate = useNavigate();

  const data = useProjectsData();
  const {
    projects,
    loading,
    isGeocoding,
    viewMode,
    setViewMode,
    expandedDivers,
    toggleDiversExpanded,
    editingId,
    formData,
    setFormData,
    showDiversForm,
    setShowDiversForm,
    diversFormData,
    setDiversFormData,
    showSubProjectModal,
    setShowSubProjectModal,
    subProjectFormData,
    setSubProjectFormData,
    isGeocodingSubProject,
    isSavingSubProject,
    filteredProjects,
    diversProjects,
    archivedSubProjects,
    getSubProjectsForParent,
    getParentDiversNumber,
  } = data;

  const {
    handleAddressSearch,
    handleResetForm,
    handleEdit,
    handleSave,
    toggleArchive,
    handleDelete,
    handleDeleteSubProject,
    handleToggleSubProjectArchive,
    handleArchiveDiversGroup,
    handleReactivateDiversGroup,
    handleDeleteDiversGroup,
    handleCreateDiversGroup,
    handleSubProjectAddressSearch,
    handleCreateSubProject,
  } = useProjectsActions({
    projects: data.projects,
    subProjects: data.subProjects,
    loadProjects: data.loadProjects,
    setLoading: data.setLoading,
    editingId: data.editingId,
    setEditingId: data.setEditingId,
    formData: data.formData,
    setFormData: data.setFormData,
    setIsGeocoding: data.setIsGeocoding,
    diversFormData: data.diversFormData,
    setDiversFormData: data.setDiversFormData,
    setShowDiversForm: data.setShowDiversForm,
    subProjectFormData: data.subProjectFormData,
    setSubProjectFormData: data.setSubProjectFormData,
    setShowSubProjectModal: data.setShowSubProjectModal,
    setIsGeocodingSubProject: data.setIsGeocodingSubProject,
    setIsSavingSubProject: data.setIsSavingSubProject,
  });

  return (
    <div style={{ fontFamily: 'Inter, sans-serif', paddingBottom: '80px', background: '#f8fafc', minHeight: '100vh' }}>

      {/* HEADER MODERNE */}
      <div style={{
        background: 'linear-gradient(135deg, #4f46e5 0%, #6366f1 100%)',
        padding: '24px 30px',
        marginBottom: '30px',
        borderRadius: '0 0 24px 24px',
        boxShadow: '0 4px 20px rgba(79,70,229,0.2)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button
            onClick={() => navigate('/')}
            style={{
              background: 'rgba(255,255,255,0.1)',
              border: '1px solid rgba(255,255,255,0.2)',
              borderRadius: '12px',
              padding: '12px',
              cursor: 'pointer',
              transition: 'all 0.2s',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <ArrowLeft size={20} color="white" />
          </button>
          <div>
            <h1 style={{ margin: 0, fontSize: '1.6rem', color: 'white', fontWeight: '700' }}>Projets & Affaires</h1>
            <p style={{ margin: '4px 0 0 0', fontSize: '0.9rem', color: 'rgba(255,255,255,0.7)' }}>
              Gestion des chantiers et affaires
            </p>
          </div>
        </div>

        {/* TOGGLE ACTIFS / ARCHIVÉS */}
        <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
          <button
            onClick={() => setViewMode('active')}
            style={{
              padding: '12px 24px',
              borderRadius: '12px',
              background: viewMode === 'active' ? 'white' : 'rgba(255,255,255,0.1)',
              color: viewMode === 'active' ? '#4f46e5' : 'rgba(255,255,255,0.8)',
              cursor: 'pointer',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              boxShadow: viewMode === 'active' ? '0 4px 12px rgba(0,0,0,0.15)' : 'none',
              border: viewMode === 'active' ? 'none' : '1px solid rgba(255,255,255,0.2)',
              fontSize: '0.95rem',
              transition: 'all 0.25s ease'
            }}
          >
            <LayoutList size={18} /> Chantiers Actifs
            <span style={{
              background: viewMode === 'active' ? '#4f46e5' : 'rgba(255,255,255,0.2)',
              color: 'white',
              padding: '2px 10px',
              borderRadius: '20px',
              fontSize: '0.8rem',
              fontWeight: '700'
            }}>
              {projects.filter(p => p.is_active).length}
            </span>
          </button>
          <button
            onClick={() => setViewMode('archived')}
            style={{
              padding: '12px 24px',
              borderRadius: '12px',
              background: viewMode === 'archived' ? 'white' : 'rgba(255,255,255,0.1)',
              color: viewMode === 'archived' ? '#64748b' : 'rgba(255,255,255,0.8)',
              cursor: 'pointer',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              boxShadow: viewMode === 'archived' ? '0 4px 12px rgba(0,0,0,0.15)' : 'none',
              border: viewMode === 'archived' ? 'none' : '1px solid rgba(255,255,255,0.2)',
              fontSize: '0.95rem',
              transition: 'all 0.25s ease'
            }}
          >
            <Archive size={18} /> Chantiers Archivés
            <span style={{
              background: viewMode === 'archived' ? '#64748b' : 'rgba(255,255,255,0.2)',
              color: 'white',
              padding: '2px 10px',
              borderRadius: '20px',
              fontSize: '0.8rem',
              fontWeight: '700'
            }}>
              {projects.filter(p => !p.is_active).length}
            </span>
          </button>
        </div>
      </div>

      {/* CONTENU PRINCIPAL */}
      <div style={{ padding: '0 20px' }}>

      {/* FORMULAIRE */}
      <Card padding="lg" style={{ marginBottom: '30px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
        <h3 style={{ marginTop: 0, marginBottom: '20px', color: '#334155', display:'flex', alignItems:'center', gap:'10px', fontSize:'1.1rem' }}>
          <div style={{ background: editingId ? '#eff6ff' : '#e0e7ff', padding:'8px', borderRadius:'8px', color:'#4f46e5' }}>
            <FolderPlus size={20} />
          </div>
          {editingId ? 'Modifier le projet' : 'Nouveau Chantier'}
        </h3>

        <form onSubmit={handleSave} style={{ display: 'grid', gap: '20px' }}>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
            <label style={{fontWeight:'600', color:'#475569', fontSize:'0.9rem'}}>Code Affaire <span style={{color:'#ef4444'}}>*</span>
              <input type="text" required value={formData.code} onChange={e => setFormData({...formData, code: e.target.value})} placeholder="Ex: P25-042" style={{ width: '100%', padding: '12px', marginTop:'6px', border:'1px solid #cbd5e1', borderRadius:'8px', fontSize:'1rem' }} />
            </label>

            <label style={{fontWeight:'600', color:'#475569', fontSize:'0.9rem'}}>Nom du Chantier <span style={{color:'#ef4444'}}>*</span>
              <input type="text" required value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} placeholder="Ex: Rénovation Mairie" style={{ width: '100%', padding: '12px', marginTop:'6px', border:'1px solid #cbd5e1', borderRadius:'8px', fontSize:'1rem' }} />
            </label>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
            <label style={{fontWeight:'600', color:'#475569', fontSize:'0.9rem'}}>Budget Heures CHANTIER
              {/* CORRECTION ANTI-NAN : Gestion sécurisée de la saisie numérique */}
              <input
                type="number"
                value={formData.estimated_hours === 0 ? '' : formData.estimated_hours}
                onChange={e => {
                  const val = e.target.value === '' ? 0 : parseFloat(e.target.value);
                  setFormData({...formData, estimated_hours: val});
                }}
                placeholder="0"
                style={{ width: '100%', padding: '12px', marginTop:'6px', border:'1px solid #cbd5e1', borderRadius:'8px', fontSize:'1rem' }}
              />
            </label>

            <label style={{fontWeight:'600', color:'#475569', fontSize:'0.9rem'}}>Budget Heures BUREAU D'ÉTUDE
              <input
                type="number"
                value={formData.estimated_hours_be === 0 ? '' : formData.estimated_hours_be}
                onChange={e => {
                  const val = e.target.value === '' ? 0 : parseFloat(e.target.value);
                  setFormData({...formData, estimated_hours_be: val});
                }}
                placeholder="0"
                style={{ width: '100%', padding: '12px', marginTop:'6px', border:'1px solid #cbd5e1', borderRadius:'8px', fontSize:'1rem', backgroundColor:'#f0f9ff' }}
              />
            </label>
          </div>

          {/* SECTION MONTANT DEVIS */}
          <div style={{ background: '#fffbeb', padding: '16px 20px', borderRadius: '12px', border: '1px solid #fde68a', display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.9rem', fontWeight: '700', color: '#92400e' }}>
              <FileText size={16} color="#92400e" /> Montant du Devis
            </div>
            <label style={{ fontWeight: '600', color: '#78350f', fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
              Devis HT (€)
              <input
                type="number"
                min="0"
                step="100"
                value={formData.devis_amount === undefined || formData.devis_amount === null ? '' : formData.devis_amount}
                onChange={e => {
                  const val = e.target.value === '' ? undefined : parseFloat(e.target.value);
                  setFormData({ ...formData, devis_amount: val });
                }}
                placeholder="Ex: 287000"
                style={{
                  width: '180px',
                  padding: '10px 14px',
                  border: '1px solid #fcd34d',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  background: 'white'
                }}
              />
              <span style={{ color: '#a16207', fontSize: '0.8rem', fontWeight: '400' }}>
                Utilisé pour calculer la marge brute dans Reporting
              </span>
            </label>
          </div>

          {/* SECTION ADRESSE & GEO */}
          <div style={{ background: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
            <div style={{ marginBottom: '10px', fontSize: '0.9rem', fontWeight: '700', color: '#1e293b', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <MapPin size={16} className="text-red-500" /> Localisation & Zone
            </div>

            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              <div style={{ flex: 1, minWidth: '300px' }}>
                <div style={{ position: 'relative' }}>
                  <input
                    type="text"
                    placeholder="Saisir l'adresse du chantier (ex: 10 rue de la Paix, Paris)..."
                    value={formData.address || ''}
                    onChange={e => setFormData({...formData, address: e.target.value})}
                    onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), handleAddressSearch())}
                    style={{ width: '100%', padding: '12px 40px 12px 12px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize:'0.95rem' }}
                  />
                  <button
                    type="button"
                    onClick={handleAddressSearch}
                    disabled={isGeocoding}
                    title="Rechercher l'adresse et calculer la zone"
                    style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', background: 'transparent', border: 'none', cursor: 'pointer', color: '#2563eb' }}
                  >
                    {isGeocoding ? <Loader2 size={20} className="animate-spin" /> : <Search size={20} />}
                  </button>
                </div>
                <div style={{ fontSize: '0.75rem', color: '#64748b', marginTop: '4px' }}>Appuyez sur la loupe pour calculer la zone automatiquement.</div>
              </div>

              {/* RÉSULTATS GEO */}
              <div style={{ display:'flex', gap:'10px' }}>
                <div style={{ background:'white', padding:'8px 16px', borderRadius:'8px', border:'1px solid #cbd5e1', display:'flex', flexDirection:'column', alignItems:'center', minWidth:'80px', justifyContent:'center' }}>
                  <span style={{ fontSize:'0.7rem', color:'#64748b', textTransform:'uppercase', fontWeight:'700' }}>ZONE</span>
                  <span style={{ fontWeight:'800', fontSize:'1.4rem', color: formData.zone ? (formData.zone === 'GD' ? '#dc2626' : '#2563eb') : '#cbd5e1', lineHeight: 1 }}>
                    {formData.zone ? (formData.zone === 'GD' ? 'GD' : formData.zone) : '-'}
                  </span>
                </div>
                <div style={{ background:'white', padding:'8px 16px', borderRadius:'8px', border:'1px solid #cbd5e1', display:'flex', flexDirection:'column', justifyContent:'center', minWidth:'140px' }}>
                  <span style={{ fontSize:'0.75rem', color:'#64748b', fontFamily:'monospace' }}>Lat: {formData.lat?.toFixed(4) || '-'}</span>
                  <span style={{ fontSize:'0.75rem', color:'#64748b', fontFamily:'monospace' }}>Lng: {formData.lng?.toFixed(4) || '-'}</span>
                </div>
              </div>
            </div>
          </div>

          {/* SECTION GRAND DÉPLACEMENT (visible uniquement si zone = GD) */}
          {formData.zone === 'GD' && (
            <div style={{ background: 'linear-gradient(135deg, #fef2f2, #fee2e2)', padding: '20px', borderRadius: '12px', border: '1px solid #fecaca' }}>
              <div style={{ marginBottom: '16px', fontSize: '0.9rem', fontWeight: '700', color: '#dc2626', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <BedDouble size={20} /> Configuration Grand Déplacement
              </div>
              <p style={{ fontSize: '0.85rem', color: '#991b1b', marginBottom: '16px', lineHeight: 1.5 }}>
                Ce chantier est situé à plus de 80 km du siège. Configurez les indemnités de découché qui seront appliquées automatiquement.
              </p>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
                <label style={{ fontWeight: '600', color: '#7f1d1d', fontSize: '0.9rem' }}>
                  Montant forfaitaire (€/jour)
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    value={formData.gd_amount === undefined ? '' : formData.gd_amount}
                    onChange={e => {
                      const val = e.target.value === '' ? undefined : parseFloat(e.target.value);
                      setFormData({ ...formData, gd_amount: val });
                    }}
                    placeholder="Ex: 85.00"
                    style={{
                      width: '100%',
                      padding: '12px',
                      marginTop: '6px',
                      border: '1px solid #fca5a5',
                      borderRadius: '8px',
                      fontSize: '1rem',
                      background: 'white'
                    }}
                  />
                </label>
                <label style={{ fontWeight: '600', color: '#7f1d1d', fontSize: '0.9rem' }}>
                  Temps de route (heures d'amplitude)
                  <input
                    type="number"
                    step="0.5"
                    min="0"
                    value={formData.gd_travel_hours === undefined ? '' : formData.gd_travel_hours}
                    onChange={e => {
                      const val = e.target.value === '' ? undefined : parseFloat(e.target.value);
                      setFormData({ ...formData, gd_travel_hours: val });
                    }}
                    placeholder="Ex: 2.5"
                    style={{
                      width: '100%',
                      padding: '12px',
                      marginTop: '6px',
                      border: '1px solid #fca5a5',
                      borderRadius: '8px',
                      fontSize: '1rem',
                      background: 'white'
                    }}
                  />
                </label>
              </div>
              <div style={{ fontSize: '0.75rem', color: '#b91c1c', marginTop: '12px', fontStyle: 'italic' }}>
                Ces valeurs seront automatiquement appliquées lorsqu'un employé active "Grand Déplacement" pour ce chantier.
              </div>
            </div>
          )}

          {/* BOUTONS ACTIONS */}
          <div style={{ gridColumn: '1 / -1', marginTop: '10px', display:'flex', gap:'10px', borderTop:'1px solid #e2e8f0', paddingTop:'20px' }}>
            {editingId && (
              <button type="button" onClick={handleResetForm} style={{ padding: '12px 20px', background: '#f1f5f9', border: '1px solid #cbd5e1', borderRadius: '8px', cursor: 'pointer', fontWeight:'600', color:'#475569', display:'flex', alignItems:'center', gap:'8px' }}>
                <X size={18} /> Annuler
              </button>
            )}
            <button type="submit" disabled={loading} style={{ padding: '12px 25px', background: '#4f46e5', color: 'white', border: 'none', borderRadius: '8px', cursor: loading ? 'wait' : 'pointer', fontWeight: '600', boxShadow:'0 2px 4px rgba(79,70,229,0.2)', display:'flex', alignItems:'center', gap:'8px', marginLeft: 'auto' }}>
              <Save size={18} /> {loading ? 'Sauvegarde...' : (editingId ? 'Enregistrer les modifications' : 'Créer le Projet')}
            </button>
          </div>
        </form>
      </Card>

      {/* TABLEAU DES PROJETS */}
      {loading && projects.length === 0 ? (
        <LoadingSpinner message="Chargement des projets..." />
      ) : filteredProjects.length === 0 ? (
        <EmptyState
          message={viewMode === 'active' ? 'Aucun chantier actif' : 'Aucun chantier archivé'}
          icon={<Building2 size={36} />}
        />
      ) : (
        <div style={{
          overflowX: 'auto',
          background: 'white',
          borderRadius: '20px',
          border: '1px solid #e2e8f0',
          boxShadow: '0 10px 25px -5px rgba(0,0,0,0.05), 0 4px 6px -2px rgba(0,0,0,0.03)'
        }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
            <thead style={{ background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', borderBottom: '1px solid #e2e8f0' }}>
              <tr>
                <th style={{ width: '12%', padding: '18px 16px', textAlign: 'left', fontSize: '0.75rem', color: '#64748b', textTransform: 'uppercase', fontWeight: '700', letterSpacing: '0.05em' }}>Code</th>
                <th style={{ padding: '18px 16px', textAlign: 'left', fontSize: '0.75rem', color: '#64748b', textTransform: 'uppercase', fontWeight: '700', letterSpacing: '0.05em' }}>Chantier</th>
                <th style={{ width: '8%', padding: '18px 16px', textAlign: 'center', fontSize: '0.75rem', color: '#64748b', textTransform: 'uppercase', fontWeight: '700', letterSpacing: '0.05em' }}>Zone</th>
                <th style={{ width: '10%', padding: '18px 16px', textAlign: 'center', fontSize: '0.75rem', color: '#64748b', textTransform: 'uppercase', fontWeight: '700', letterSpacing: '0.05em' }}>Budget CH</th>
                <th style={{ width: '10%', padding: '18px 16px', textAlign: 'center', fontSize: '0.75rem', color: '#64748b', textTransform: 'uppercase', fontWeight: '700', letterSpacing: '0.05em' }}>Budget BE</th>
                <th style={{ width: '12%', padding: '18px 16px', textAlign: 'center', fontSize: '0.75rem', color: '#f59e0b', textTransform: 'uppercase', fontWeight: '700', letterSpacing: '0.05em' }}>Devis HT</th>
                <th style={{ width: '140px', padding: '18px 16px', textAlign: 'right', fontSize: '0.75rem', color: '#64748b', textTransform: 'uppercase', fontWeight: '700', letterSpacing: '0.05em' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredProjects.map((p, index) => (
                <tr
                  key={p.id}
                  style={{
                    borderBottom: index < filteredProjects.length - 1 ? '1px solid #f1f5f9' : 'none',
                    background: 'white',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseOver={(e) => { e.currentTarget.style.background = '#fafbfc'; }}
                  onMouseOut={(e) => { e.currentTarget.style.background = 'white'; }}
                >
                  <td style={{ padding: '18px 16px' }}>
                    <span style={{
                      fontWeight: '700',
                      color: '#4f46e5',
                      fontFamily: 'monospace',
                      background: 'linear-gradient(135deg, #eff6ff, #e0e7ff)',
                      padding: '6px 12px',
                      borderRadius: '8px',
                      fontSize: '0.95rem'
                    }}>
                      {p.code}
                    </span>
                  </td>
                  <td style={{ padding: '18px 16px', overflow: 'hidden' }}>
                    <div title={p.name} style={{ fontWeight: '600', color: '#1e293b', fontSize: '1rem', display: 'flex', alignItems: 'center', gap: '8px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {/* Badge JLO/GP Divers pour les chantiers Divers */}
                      {p.category === 'divers' && p.parent_entity && (
                        <span style={{
                          background: getEntityColors(p.parent_entity).bg,
                          color: getEntityColors(p.parent_entity).text,
                          padding: '3px 8px',
                          borderRadius: '6px',
                          fontSize: '0.75rem',
                          fontWeight: '700',
                          border: `1px solid ${getEntityColors(p.parent_entity).border}`,
                          flexShrink: 0
                        }}>
                          {p.parent_entity} Divers
                        </span>
                      )}
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.name}</span>
                    </div>
                    {p.address && (
                      <div title={p.address} style={{ fontSize: '0.85rem', color: '#64748b', display: 'flex', alignItems: 'center', gap: '4px', marginTop: '4px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        <MapPin size={12} style={{ flexShrink: 0 }} /> <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.address}</span>
                      </div>
                    )}
                  </td>
                  <td style={{ padding: '18px 16px', textAlign: 'center' }}>
                    {p.zone ? (
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                        <span style={{
                          background: p.zone === 'GD' ? 'linear-gradient(135deg, #fef2f2, #fee2e2)' : 'linear-gradient(135deg, #f3e8ff, #e9d5ff)',
                          color: p.zone === 'GD' ? '#dc2626' : '#7e22ce',
                          padding: '6px 12px',
                          borderRadius: '20px',
                          fontWeight: '700',
                          fontSize: '0.85rem'
                        }}>Z{p.zone}</span>
                        {p.zone === 'GD' && (p.gd_amount || p.gd_travel_hours) && (
                          <span style={{ fontSize: '0.7rem', color: '#b91c1c', fontWeight: '500' }}>
                            {p.gd_amount ? `${p.gd_amount}€` : ''}{p.gd_amount && p.gd_travel_hours ? ' · ' : ''}{p.gd_travel_hours ? `${p.gd_travel_hours}h` : ''}
                          </span>
                        )}
                      </div>
                    ) : <span style={{ color: '#cbd5e1' }}>—</span>}
                  </td>
                  <td style={{ padding: '18px 16px', textAlign: 'center', fontWeight: '600', color: '#334155' }}>
                    {p.estimated_hours}h
                  </td>
                  <td style={{ padding: '18px 16px', textAlign: 'center', fontWeight: '600', color: '#0ea5e9' }}>
                    {p.estimated_hours_be || 0}h
                  </td>
                  <td style={{ padding: '18px 16px', textAlign: 'center' }}>
                    {p.devis_amount != null ? (
                      <span style={{
                        fontWeight: '700',
                        color: '#92400e',
                        background: '#fffbeb',
                        padding: '4px 10px',
                        borderRadius: '8px',
                        border: '1px solid #fde68a',
                        fontSize: '0.88rem'
                      }}>
                        {new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 }).format(p.devis_amount)} €
                      </span>
                    ) : (
                      <span style={{ color: '#cbd5e1' }}>—</span>
                    )}
                  </td>
                  <td style={{ padding: '18px 16px', textAlign: 'right' }}>
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                      <button
                        onClick={() => handleEdit(p)}
                        title="Modifier"
                        style={{
                          background: 'linear-gradient(145deg, #ffffff, #eff6ff)',
                          border: '1px solid #bfdbfe',
                          borderRadius: '10px',
                          padding: '10px',
                          cursor: 'pointer',
                          color: '#3b82f6',
                          transition: 'all 0.2s ease',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <Edit2 size={16} />
                      </button>
                      <button
                        onClick={() => toggleArchive(p)}
                        title={p.is_active ? "Archiver" : "Réactiver"}
                        style={{
                          background: p.is_active ? 'linear-gradient(145deg, #ffffff, #f8fafc)' : 'linear-gradient(145deg, #ecfdf5, #d1fae5)',
                          border: p.is_active ? '1px solid #e2e8f0' : '1px solid #86efac',
                          borderRadius: '10px',
                          padding: '10px',
                          cursor: 'pointer',
                          color: p.is_active ? '#64748b' : '#10b981',
                          transition: 'all 0.2s ease',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        {p.is_active ? <Archive size={16} /> : <RefreshCw size={16} />}
                      </button>
                      {/* Bouton suppression définitive */}
                      <button
                        onClick={() => handleDelete(p)}
                        title="Supprimer définitivement"
                        style={{
                          background: 'linear-gradient(145deg, #fef2f2, #fee2e2)',
                          border: '1px solid #fecaca',
                          borderRadius: '10px',
                          padding: '10px',
                          cursor: 'pointer',
                          color: '#dc2626',
                          transition: 'all 0.2s ease',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* SECTION PROJETS DIVERS (JLO / GP) */}
      {(diversProjects.length > 0 || viewMode === 'active') && (
        <div style={{ marginTop: '30px' }}>
          <h3 style={{
            fontSize: '1rem',
            fontWeight: '700',
            color: '#475569',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}>
            <Users size={20} color="#6366f1" />
            Affaires Diverses (Regroupées)
            <button
              onClick={() => setShowDiversForm(!showDiversForm)}
              style={{
                marginLeft: 'auto',
                padding: '8px 16px',
                background: showDiversForm ? '#f1f5f9' : 'linear-gradient(135deg, #6366f1, #4f46e5)',
                color: showDiversForm ? '#64748b' : 'white',
                border: showDiversForm ? '1px solid #e2e8f0' : 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '0.85rem',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              {showDiversForm ? <X size={16} /> : <FolderPlus size={16} />}
              {showDiversForm ? 'Annuler' : 'Nouveau groupe Divers'}
            </button>
          </h3>

          {/* Formulaire création groupe Divers */}
          {showDiversForm && (
            <div style={{
              background: 'linear-gradient(135deg, #f0f9ff, #e0f2fe)',
              padding: '20px',
              borderRadius: '12px',
              border: '1px solid #bae6fd',
              marginBottom: '16px'
            }}>
              <h4 style={{ margin: '0 0 16px 0', color: '#0369a1', fontSize: '1rem', fontWeight: '700' }}>
                Créer un nouveau groupe Divers
              </h4>
              <p style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '16px' }}>
                Un groupe Divers permet de regrouper les chantiers sans numéro d'affaire.
                Créez un nouveau groupe lorsque vous souhaitez démarrer une nouvelle période (ex: semestre, année).
              </p>
              <form onSubmit={handleCreateDiversGroup} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
                <label style={{ fontWeight: '600', color: '#0c4a6e', fontSize: '0.9rem' }}>
                  Numéro Divers <span style={{ color: '#ef4444' }}>*</span>
                  <input
                    type="text"
                    required
                    value={diversFormData.code}
                    onChange={e => setDiversFormData({ ...diversFormData, code: e.target.value })}
                    placeholder="Ex: JLO-2025-S2"
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      marginTop: '6px',
                      border: '1px solid #7dd3fc',
                      borderRadius: '8px',
                      fontSize: '0.95rem',
                      background: 'white'
                    }}
                  />
                </label>
                <label style={{ fontWeight: '600', color: '#0c4a6e', fontSize: '0.9rem' }}>
                  Nom du groupe <span style={{ color: '#ef4444' }}>*</span>
                  <input
                    type="text"
                    required
                    value={diversFormData.name}
                    onChange={e => setDiversFormData({ ...diversFormData, name: e.target.value })}
                    placeholder="Ex: JLO Divers 2025 S2"
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      marginTop: '6px',
                      border: '1px solid #7dd3fc',
                      borderRadius: '8px',
                      fontSize: '0.95rem',
                      background: 'white'
                    }}
                  />
                </label>
                <label style={{ fontWeight: '600', color: '#0c4a6e', fontSize: '0.9rem' }}>
                  Entité parente <span style={{ color: '#ef4444' }}>*</span>
                  <select
                    required
                    value={diversFormData.parent_entity}
                    onChange={e => setDiversFormData({ ...diversFormData, parent_entity: e.target.value })}
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      marginTop: '6px',
                      border: '1px solid #7dd3fc',
                      borderRadius: '8px',
                      fontSize: '0.95rem',
                      background: 'white'
                    }}
                  >
                    <option value="">Sélectionner...</option>
                    <option value="JLO">JLO</option>
                    <option value="GP">GP</option>
                    <option value="WAG">WAG</option>
                  </select>
                </label>
                <div style={{ display: 'flex', alignItems: 'flex-end', gap: '10px' }}>
                  <button
                    type="submit"
                    disabled={loading}
                    style={{
                      padding: '10px 20px',
                      background: '#0284c7',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: loading ? 'wait' : 'pointer',
                      fontWeight: '600',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}
                  >
                    <Save size={16} /> {loading ? 'Création...' : 'Créer le groupe'}
                  </button>
                </div>
              </form>
            </div>
          )}

          {/* Message si aucun groupe Divers */}
          {diversProjects.length === 0 && !showDiversForm && (
            <div style={{
              textAlign: 'center',
              padding: '40px 20px',
              background: 'linear-gradient(145deg, #ffffff, #f8fafc)',
              borderRadius: '16px',
              border: '2px dashed #e2e8f0',
              color: '#94a3b8'
            }}>
              <Users size={40} color="#cbd5e1" style={{ marginBottom: '12px' }} />
              <p style={{ fontSize: '1rem', fontWeight: '500', margin: '0 0 8px 0' }}>
                Aucun groupe Divers actif
              </p>
              <p style={{ fontSize: '0.85rem', margin: 0 }}>
                Cliquez sur "Nouveau groupe Divers" pour créer un groupe de chantiers sans numéro d'affaire.
              </p>
            </div>
          )}

          {diversProjects.map(diversProject => {
            const isExpanded = expandedDivers.has(diversProject.id);
            const projectSubProjects = getSubProjectsForParent(diversProject.id);
            const ec = getEntityColors(diversProject.parent_entity);
            const entityColor = ec.color;
            const entityBg = ec.bg;
            const entityBorder = ec.border;

            return (
              <div
                key={diversProject.id}
                style={{
                  background: 'white',
                  borderRadius: '12px',
                  border: `1px solid ${entityBorder}`,
                  marginBottom: '12px',
                  overflow: 'hidden'
                }}
              >
                {/* Header du projet Divers */}
                <div
                  onClick={() => toggleDiversExpanded(diversProject.id)}
                  style={{
                    padding: '16px 20px',
                    background: entityBg,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    {isExpanded ? <ChevronUp size={20} color={entityColor} /> : <ChevronDown size={20} color={entityColor} />}
                    <div>
                      <div style={{ fontWeight: '700', fontSize: '1.1rem', color: entityColor }}>
                        {diversProject.name}
                      </div>
                      <div style={{ fontSize: '0.8rem', color: '#64748b', fontFamily: 'monospace' }}>
                        {diversProject.code}
                      </div>
                    </div>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: '0.7rem', color: '#64748b', textTransform: 'uppercase' }}>Sous-chantiers</div>
                      <div style={{ fontWeight: '800', fontSize: '1.3rem', color: entityColor }}>{projectSubProjects.length}</div>
                    </div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      {viewMode === 'active' ? (
                        <>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              const parentNumber = getParentDiversNumber(diversProject.id);
                              setSubProjectFormData({
                                divers_number: parentNumber,
                                name: '',
                                address: '',
                                lat: undefined,
                                lng: undefined,
                                zone: undefined,
                                parent_project_id: diversProject.id
                              });
                              setShowSubProjectModal(true);
                            }}
                            title="Ajouter un sous-chantier"
                            style={{
                              background: 'linear-gradient(135deg, #10b981, #059669)',
                              border: 'none',
                              borderRadius: '8px',
                              padding: '8px 12px',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px',
                              fontSize: '0.8rem',
                              fontWeight: '600',
                              color: 'white',
                              boxShadow: '0 2px 4px rgba(16,185,129,0.3)'
                            }}
                          >
                            <FolderPlus size={14} /> Ajouter
                          </button>
                          <button
                            onClick={(e) => { e.stopPropagation(); handleEdit(diversProject); }}
                            style={{
                              background: 'white',
                              border: `1px solid ${entityBorder}`,
                              borderRadius: '8px',
                              padding: '8px 12px',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px',
                              fontSize: '0.8rem',
                              fontWeight: '600',
                              color: '#64748b'
                            }}
                          >
                            <Edit2 size={14} /> Modifier
                          </button>
                          <button
                            onClick={(e) => { e.stopPropagation(); handleArchiveDiversGroup(diversProject); }}
                            title="Archiver le groupe entier (parent + sous-chantiers)"
                            style={{
                              background: '#fef3c7',
                              border: '1px solid #fcd34d',
                              borderRadius: '8px',
                              padding: '8px 12px',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px',
                              fontSize: '0.8rem',
                              fontWeight: '600',
                              color: '#b45309'
                            }}
                          >
                            <Archive size={14} /> Archiver tout
                          </button>
                          <button
                            onClick={(e) => { e.stopPropagation(); handleDeleteDiversGroup(diversProject); }}
                            title="Supprimer ce groupe Divers (uniquement si vide)"
                            style={{
                              background: '#fee2e2',
                              border: '1px solid #fca5a5',
                              borderRadius: '8px',
                              padding: '8px 12px',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px',
                              fontSize: '0.8rem',
                              fontWeight: '600',
                              color: '#dc2626'
                            }}
                          >
                            <Trash2 size={14} /> Supprimer
                          </button>
                        </>
                      ) : (
                        <button
                          onClick={(e) => { e.stopPropagation(); handleReactivateDiversGroup(diversProject); }}
                          title="Réactiver le groupe entier (parent + sous-chantiers)"
                          style={{
                            background: '#ecfdf5',
                            border: '1px solid #86efac',
                            borderRadius: '8px',
                            padding: '8px 12px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            fontSize: '0.8rem',
                            fontWeight: '600',
                            color: '#059669'
                          }}
                        >
                          <RefreshCw size={14} /> Réactiver tout
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                {/* Liste des sous-chantiers */}
                {isExpanded && (
                  <div style={{ padding: '0' }}>
                    {projectSubProjects.length === 0 ? (
                      <div style={{ padding: '24px', textAlign: 'center', color: '#94a3b8', fontStyle: 'italic' }}>
                        Aucun sous-chantier créé
                      </div>
                    ) : (
                      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
                        <thead>
                          <tr style={{ background: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
                            <th style={{ padding: '12px 20px', textAlign: 'left', color: '#64748b', fontWeight: '600' }}>N° Divers</th>
                            <th style={{ padding: '12px 20px', textAlign: 'left', color: '#64748b', fontWeight: '600' }}>Nom du chantier</th>
                            <th style={{ padding: '12px 20px', textAlign: 'left', color: '#64748b', fontWeight: '600' }}>Adresse</th>
                            <th style={{ padding: '12px 20px', textAlign: 'center', color: '#64748b', fontWeight: '600' }}>Zone</th>
                            <th style={{ padding: '12px 20px', textAlign: 'right', color: '#64748b', fontWeight: '600' }}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {projectSubProjects.map((sub, idx) => (
                            <tr
                              key={sub.id}
                              style={{
                                borderTop: '1px solid #f1f5f9',
                                background: idx % 2 === 0 ? 'white' : '#fafbfc'
                              }}
                            >
                              <td style={{ padding: '14px 20px' }}>
                                <span style={{
                                  background: '#f1f5f9',
                                  padding: '4px 10px',
                                  borderRadius: '6px',
                                  fontFamily: 'monospace',
                                  fontWeight: '700',
                                  fontSize: '0.85rem',
                                  color: '#475569'
                                }}>
                                  {sub.divers_number}
                                </span>
                              </td>
                              <td style={{ padding: '14px 20px', fontWeight: '500', color: '#1e293b' }}>
                                {sub.name}
                              </td>
                              <td style={{ padding: '14px 20px', color: '#64748b', fontSize: '0.85rem' }}>
                                {sub.address ? (
                                  <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <MapPin size={12} /> {sub.address}
                                  </span>
                                ) : (
                                  <span style={{ fontStyle: 'italic', color: '#94a3b8' }}>Non renseignée</span>
                                )}
                              </td>
                              <td style={{ padding: '14px 20px', textAlign: 'center' }}>
                                {sub.zone ? (
                                  <span style={{
                                    background: '#f3e8ff',
                                    color: '#7e22ce',
                                    padding: '4px 10px',
                                    borderRadius: '12px',
                                    fontWeight: '600',
                                    fontSize: '0.8rem'
                                  }}>
                                    {sub.zone}
                                  </span>
                                ) : (
                                  <span style={{ color: '#94a3b8' }}>-</span>
                                )}
                              </td>
                              <td style={{ padding: '14px 20px', textAlign: 'right' }}>
                                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                                  <button
                                    onClick={() => handleToggleSubProjectArchive(sub)}
                                    title={sub.is_active ? "Archiver ce sous-chantier" : "Réactiver ce sous-chantier"}
                                    style={{
                                      background: sub.is_active ? '#fef3c7' : '#ecfdf5',
                                      border: sub.is_active ? '1px solid #fcd34d' : '1px solid #86efac',
                                      borderRadius: '6px',
                                      padding: '6px 10px',
                                      cursor: 'pointer',
                                      display: 'inline-flex',
                                      alignItems: 'center',
                                      gap: '6px',
                                      fontSize: '0.8rem',
                                      color: sub.is_active ? '#b45309' : '#10b981',
                                      fontWeight: '500'
                                    }}
                                  >
                                    {sub.is_active ? <Archive size={14} /> : <RefreshCw size={14} />}
                                    {sub.is_active ? 'Archiver' : 'Réactiver'}
                                  </button>
                                  <button
                                    onClick={() => handleDeleteSubProject(sub)}
                                    title="Supprimer définitivement"
                                    style={{
                                      background: '#fef2f2',
                                      border: '1px solid #fecaca',
                                      borderRadius: '6px',
                                      padding: '6px 10px',
                                      cursor: 'pointer',
                                      display: 'inline-flex',
                                      alignItems: 'center',
                                      gap: '6px',
                                      fontSize: '0.8rem',
                                      color: '#dc2626',
                                      fontWeight: '500'
                                    }}
                                  >
                                    <Trash2 size={14} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* SECTION SOUS-CHANTIERS ARCHIVÉS (en mode archivé uniquement) */}
      {viewMode === 'archived' && archivedSubProjects.length > 0 && (
        <div style={{ marginTop: '30px' }}>
          <h3 style={{
            fontSize: '1rem',
            fontWeight: '700',
            color: '#64748b',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}>
            <Archive size={20} color="#64748b" />
            Sous-chantiers Divers Archivés
            <span style={{
              background: '#f1f5f9',
              color: '#64748b',
              padding: '2px 10px',
              borderRadius: '20px',
              fontSize: '0.8rem',
              fontWeight: '700'
            }}>
              {archivedSubProjects.length}
            </span>
          </h3>

          <div style={{
            background: 'white',
            borderRadius: '12px',
            border: '1px solid #e2e8f0',
            overflow: 'hidden'
          }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                  <th style={{ padding: '12px 20px', textAlign: 'left', color: '#64748b', fontWeight: '600' }}>Projet Parent</th>
                  <th style={{ padding: '12px 20px', textAlign: 'left', color: '#64748b', fontWeight: '600' }}>N° Divers</th>
                  <th style={{ padding: '12px 20px', textAlign: 'left', color: '#64748b', fontWeight: '600' }}>Nom du chantier</th>
                  <th style={{ padding: '12px 20px', textAlign: 'left', color: '#64748b', fontWeight: '600' }}>Adresse</th>
                  <th style={{ padding: '12px 20px', textAlign: 'center', color: '#64748b', fontWeight: '600' }}>Zone</th>
                  <th style={{ padding: '12px 20px', textAlign: 'right', color: '#64748b', fontWeight: '600' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {archivedSubProjects.map((sub, idx) => {
                  const parentProject = projects.find(p => p.id === sub.parent_project_id);
                  const entityColor = getEntityColors(parentProject?.parent_entity).color;

                  return (
                    <tr
                      key={sub.id}
                      style={{
                        borderTop: idx > 0 ? '1px solid #f1f5f9' : 'none',
                        background: idx % 2 === 0 ? 'white' : '#fafbfc'
                      }}
                    >
                      <td style={{ padding: '14px 20px' }}>
                        <span style={{
                          background: getEntityColors(parentProject?.parent_entity).bg,
                          color: entityColor,
                          padding: '4px 10px',
                          borderRadius: '6px',
                          fontSize: '0.8rem',
                          fontWeight: '600'
                        }}>
                          {parentProject?.name || 'Inconnu'}
                        </span>
                      </td>
                      <td style={{ padding: '14px 20px' }}>
                        <span style={{
                          background: '#f1f5f9',
                          padding: '4px 10px',
                          borderRadius: '6px',
                          fontFamily: 'monospace',
                          fontWeight: '700',
                          fontSize: '0.85rem',
                          color: '#475569'
                        }}>
                          {sub.divers_number}
                        </span>
                      </td>
                      <td style={{ padding: '14px 20px', fontWeight: '500', color: '#64748b' }}>
                        {sub.name}
                      </td>
                      <td style={{ padding: '14px 20px', color: '#94a3b8', fontSize: '0.85rem' }}>
                        {sub.address ? (
                          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <MapPin size={12} /> {sub.address}
                          </span>
                        ) : (
                          <span style={{ fontStyle: 'italic' }}>Non renseignée</span>
                        )}
                      </td>
                      <td style={{ padding: '14px 20px', textAlign: 'center' }}>
                        {sub.zone ? (
                          <span style={{
                            background: '#f3e8ff',
                            color: '#7e22ce',
                            padding: '4px 10px',
                            borderRadius: '12px',
                            fontWeight: '600',
                            fontSize: '0.8rem'
                          }}>
                            {sub.zone}
                          </span>
                        ) : (
                          <span style={{ color: '#94a3b8' }}>-</span>
                        )}
                      </td>
                      <td style={{ padding: '14px 20px', textAlign: 'right' }}>
                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                          <button
                            onClick={() => handleToggleSubProjectArchive(sub)}
                            title="Réactiver ce sous-chantier"
                            style={{
                              background: '#ecfdf5',
                              border: '1px solid #86efac',
                              borderRadius: '6px',
                              padding: '6px 10px',
                              cursor: 'pointer',
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '6px',
                              fontSize: '0.8rem',
                              color: '#10b981',
                              fontWeight: '500'
                            }}
                          >
                            <RefreshCw size={14} /> Réactiver
                          </button>
                          <button
                            onClick={() => handleDeleteSubProject(sub)}
                            title="Supprimer définitivement"
                            style={{
                              background: '#fef2f2',
                              border: '1px solid #fecaca',
                              borderRadius: '6px',
                              padding: '6px 10px',
                              cursor: 'pointer',
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '6px',
                              fontSize: '0.8rem',
                              color: '#dc2626',
                              fontWeight: '500'
                            }}
                          >
                            <Trash2 size={14} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      </div>

      {/* MODALE CRÉATION SOUS-CHANTIER DIVERS */}
      {showSubProjectModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          padding: '20px'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '16px',
            width: '100%',
            maxWidth: '500px',
            maxHeight: '90vh',
            overflow: 'auto',
            boxShadow: '0 20px 40px rgba(0,0,0,0.2)'
          }}>
            {/* Header modale */}
            <div style={{
              background: 'linear-gradient(135deg, #10b981, #059669)',
              padding: '20px 24px',
              borderRadius: '16px 16px 0 0'
            }}>
              <h3 style={{ margin: 0, color: 'white', fontSize: '1.2rem', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <FolderPlus size={22} />
                Nouveau sous-chantier
              </h3>
              <p style={{ margin: '6px 0 0 0', color: 'rgba(255,255,255,0.8)', fontSize: '0.85rem' }}>
                Groupe : {projects.find(p => p.id === subProjectFormData.parent_project_id)?.name || 'Inconnu'}
              </p>
            </div>

            {/* Corps de la modale */}
            <form onSubmit={handleCreateSubProject} style={{ padding: '24px' }}>
              <div style={{ display: 'grid', gap: '20px' }}>
                {/* Numéro Divers */}
                <label style={{ fontWeight: '600', color: '#475569', fontSize: '0.9rem' }}>
                  Numéro Divers <span style={{ color: '#ef4444' }}>*</span>
                  <input
                    type="text"
                    required
                    value={subProjectFormData.divers_number}
                    onChange={e => setSubProjectFormData({ ...subProjectFormData, divers_number: e.target.value })}
                    placeholder="Ex: D001, D002..."
                    style={{
                      width: '100%',
                      padding: '12px',
                      marginTop: '6px',
                      border: '1px solid #cbd5e1',
                      borderRadius: '8px',
                      fontSize: '1rem'
                    }}
                  />
                </label>

                {/* Nom du chantier */}
                <label style={{ fontWeight: '600', color: '#475569', fontSize: '0.9rem' }}>
                  Nom du chantier <span style={{ color: '#ef4444' }}>*</span>
                  <input
                    type="text"
                    required
                    value={subProjectFormData.name}
                    onChange={e => setSubProjectFormData({ ...subProjectFormData, name: e.target.value })}
                    placeholder="Ex: Intervention Mairie Le Mans"
                    style={{
                      width: '100%',
                      padding: '12px',
                      marginTop: '6px',
                      border: '1px solid #cbd5e1',
                      borderRadius: '8px',
                      fontSize: '1rem'
                    }}
                  />
                </label>

                {/* Adresse avec géocodage */}
                <div>
                  <label style={{ fontWeight: '600', color: '#475569', fontSize: '0.9rem' }}>
                    Adresse (optionnel)
                  </label>
                  <div style={{ position: 'relative', marginTop: '6px' }}>
                    <input
                      type="text"
                      value={subProjectFormData.address}
                      onChange={e => setSubProjectFormData({ ...subProjectFormData, address: e.target.value })}
                      onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), handleSubProjectAddressSearch())}
                      placeholder="Saisir l'adresse du chantier..."
                      style={{
                        width: '100%',
                        padding: '12px 45px 12px 12px',
                        border: '1px solid #cbd5e1',
                        borderRadius: '8px',
                        fontSize: '1rem'
                      }}
                    />
                    <button
                      type="button"
                      onClick={handleSubProjectAddressSearch}
                      disabled={isGeocodingSubProject}
                      title="Rechercher et calculer la zone"
                      style={{
                        position: 'absolute',
                        right: '8px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: '#10b981',
                        border: 'none',
                        borderRadius: '6px',
                        padding: '6px',
                        cursor: 'pointer',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      {isGeocodingSubProject ? <Loader2 size={18} className="animate-spin" /> : <Search size={18} />}
                    </button>
                  </div>
                  <p style={{ fontSize: '0.75rem', color: '#64748b', marginTop: '4px' }}>
                    Appuyez sur la loupe pour calculer la zone automatiquement.
                  </p>
                </div>

                {/* Zone calculée */}
                {subProjectFormData.zone && (
                  <div style={{
                    background: 'linear-gradient(135deg, #ecfdf5, #d1fae5)',
                    padding: '16px',
                    borderRadius: '12px',
                    border: '1px solid #86efac',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px'
                  }}>
                    <div style={{
                      background: 'white',
                      padding: '12px 20px',
                      borderRadius: '10px',
                      textAlign: 'center',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                    }}>
                      <div style={{ fontSize: '0.7rem', color: '#64748b', textTransform: 'uppercase', fontWeight: '600' }}>Zone</div>
                      <div style={{
                        fontWeight: '800',
                        fontSize: '1.5rem',
                        color: subProjectFormData.zone === 'GD' ? '#dc2626' : '#7e22ce'
                      }}>
                        {subProjectFormData.zone === 'GD' ? 'GD' : subProjectFormData.zone}
                      </div>
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '0.85rem', color: '#047857', fontWeight: '600' }}>Zone calculée</div>
                      <div style={{ fontSize: '0.75rem', color: '#64748b', marginTop: '2px' }}>
                        Lat: {subProjectFormData.lat?.toFixed(4)} · Lng: {subProjectFormData.lng?.toFixed(4)}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Boutons d'action */}
              <div style={{
                display: 'flex',
                gap: '12px',
                marginTop: '24px',
                paddingTop: '20px',
                borderTop: '1px solid #e2e8f0'
              }}>
                <button
                  type="button"
                  onClick={() => setShowSubProjectModal(false)}
                  style={{
                    flex: 1,
                    padding: '12px',
                    background: '#f1f5f9',
                    border: '1px solid #cbd5e1',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: '600',
                    color: '#64748b',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                  }}
                >
                  <X size={18} /> Annuler
                </button>
                <button
                  type="submit"
                  disabled={isSavingSubProject}
                  style={{
                    flex: 1,
                    padding: '12px',
                    background: 'linear-gradient(135deg, #10b981, #059669)',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: isSavingSubProject ? 'wait' : 'pointer',
                    fontWeight: '600',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    boxShadow: '0 2px 8px rgba(16,185,129,0.3)'
                  }}
                >
                  <Save size={18} /> {isSavingSubProject ? 'Création...' : 'Créer le sous-chantier'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
